import { useLayoutEffect, useRef, useCallback } from "react";
import { useDiscussion } from "./context";

export default function CommentEditor({ comment }) {
  const { editText, setEditText, setEditingId, saveEdit } = useDiscussion();
  const textareaRef = useRef(null);

  const stopPropagation = useCallback((e) => e.stopPropagation(), []);

  /**
   * При появлении редактора сразу фокусируем textarea и ставим курсор
   * в конец текста. useLayoutEffect - а не useEffect - чтобы позиция
   * курсора была выставлена до первого пейнта.
   */
  useLayoutEffect(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    ta.focus();
    const end = ta.value.length;
    ta.setSelectionRange(end, end);
  }, []);

  return (
    <div className="cm-edit" onClick={stopPropagation} role="presentation">
      <textarea
        ref={textareaRef}
        className="inp"
        rows="2"
        value={editText}
        onChange={(e) => setEditText(e.target.value)}
      />
      <div className="cm-actions">
        <button className="btn primary sm" onClick={() => saveEdit(comment)}>
          Сохранить
        </button>
        <button className="btn ghost sm" onClick={() => setEditingId(null)}>
          Отмена
        </button>
      </div>
    </div>
  );
}
